import swal from "sweetalert";
import { BACKEND } from "../context/backend";

export function getServicioService(authTokens) {
  return fetch(BACKEND+"/api/servicios/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function createServicioService(servicio, authTokens) {
  const body = JSON.stringify(servicio);

  return fetch(BACKEND+`/api/servicios/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Nuevo servicio creado!", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

export function updateServicioService(id, servicio, authTokens) {
  const body = JSON.stringify(servicio);
  return fetch(BACKEND+`/api/servicio/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Servicio editado", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

export function deleteServicioService(id, authTokens) {
  // Funcion que se encarga de eliminar a un servicio pasandole su id.
  return fetch(BACKEND+`/api/servicio/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}
